export default getText => key =>
  ({
    typing: getText('typing...', 'AV_Consult_Messages'),
    placeholder: getText('Type something', 'AV_Consult_Messages'),
  }[key])
